import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Discount } from '../../models/discount.model';
import { DiscountCode } from '../../models/discount-code.model';

@Component({
    selector: 'app-discount-code-input',
    templateUrl: './discount-code-input.component.html',
    styleUrls: ['./discount-code-input.component.scss']
})
export class DiscountCodeInputComponent implements OnInit {

    @Input() discounts            : Discount[];
    @Input() selectedDiscountCodes: DiscountCode[];

    @Output() selectedDiscountCodesChange = new EventEmitter<DiscountCode[]>();

    public labels: any = {

        codeDiscountSelectorLabel  : 'Introduzca un código de descuento',
        codeDiscountButtonLabel    : 'Añadir código',
        codeDiscountDuplicatedError: 'El código que ha introducido ya está aplicado',
        codeDiscountIncorrectError : 'El código que ha introducido no existe',
        codeDiscountSelecedLabel   : 'Códigos aplicados'

    }

    public discountCodes: DiscountCode[];
    public writtenCode  : string;
    public writtenCodes : string[];

    public showWrittenDiscountCodeError: boolean = false;
    public writtenDiscountCodeError    : string;

    ngOnInit (): void {

        this.selectedDiscountCodes = this.selectedDiscountCodes ?? [];
        this.discountCodes         = this.discounts.flatMap(d => d.discountCodes) ?? [];
        this.writtenCodes          = this.selectedDiscountCodes.map(sdc => sdc.code) ?? [];

    }

    public onWrittenCodeChange() {

        this.writtenCode = this.writtenCode.toUpperCase();

        this.showWrittenDiscountCodeError = false;
        this.writtenDiscountCodeError = null;

    }

    public applyWrittenCodeButtonClick() {



        let discountCodeIndex = this.discountCodes.findIndex(dc => dc.code.toUpperCase() === this.writtenCode.toUpperCase());
        if (discountCodeIndex === -1) {
            this.writtenDiscountCodeError = this.labels.codeDiscountIncorrectError;
            this.showWrittenDiscountCodeError = true;
            return;
        }

        let selectedDiscountCodeIndex = this.selectedDiscountCodes.findIndex(sdc => sdc.code.toUpperCase() === this.writtenCode.toUpperCase());
        if (selectedDiscountCodeIndex > -1) {
            this.writtenDiscountCodeError = this.labels.codeDiscountDuplicatedError;
            this.showWrittenDiscountCodeError = true;
            return;
        }

        let writtenDiscountCode = this.discountCodes[discountCodeIndex];
        this.selectedDiscountCodes.push(writtenDiscountCode);
        this.writtenCodes.push(this.writtenCode);
        this.onSelectedDiscountCodesChange();
        this.writtenCode = null;

    }

    public onRemoveWrittenCode(code: string) {

        let writtenCodeIndex = this.writtenCodes.findIndex(wc => wc.toUpperCase() === code.toUpperCase());
        if (writtenCodeIndex) {
            this.writtenCodes = this.writtenCodes.splice(writtenCodeIndex, 1);
        }

        this.selectedDiscountCodes = this.selectedDiscountCodes.filter(sdc => sdc.code.toUpperCase() !== code.toUpperCase());
        this.onSelectedDiscountCodesChange();

    }

    private onSelectedDiscountCodesChange() {

        this.selectedDiscountCodesChange.emit(this.selectedDiscountCodes);

    }

}
